export const GET_USER_INF = 'GET_USER_INF';

export const GET_STORE_INF = 'GET_STORE_INF';
export const GET_PRODUCT_INF = 'GET_PRODUCT_INF';
export const GET_PRODUCT_TYPE_INF = 'GET_PRODUCT_TYPE_INF';

export const GET_CART_INF = 'GET_CART_INF';
export const SET_CART_INF = 'SET_CART_INF';
export const UPDATE_CART_INF = 'UPDATE_CART_INF';

export const GET_LIST_ORDER_HISTORY = 'GET_LIST_ORDER_HISTORY';
export const GET_ORDER_DETAIL = 'GET_ORDER_DETAIL';

export const SET_GLOBAL_VARIABLE = 'SET_GLOBAL_VARIABLE';

export const GET_LIST_NOTIFICATION = 'GET_LIST_NOTIFICATION';
export const GET_COUNT_NOTIFICATION = 'GET_COUNT_NOTIFICATION';
export const SEEN_ALL_NOTIFICATION = 'SEEN_ALL_NOTIFICATION';
export const GET_NOTIFICATION = 'GET_NOTIFICATION';

export const GET_LIST_OFFER_CATEGORY = 'GET_LIST_OFFER_CATEGORY';
export const GET_LIST_OFFER = 'GET_LIST_OFFER';
export const GET_DETAIL_ENDOW = 'GET_DETAIL_ENDOW';
export const GET_EXCHANGE_SHOPPING = 'GET_EXCHANGE_SHOPPING';

export const GET_SHIPPER_MOVING = 'GET_SHIPPER_MOVING';

export const TYPING = 'TYPING'
export const CLEAR_TYPING = 'CLEAR_TYPING'
export const GET_CHAT_HISTORY = 'GET_CHAT_HISTORY'
export const GET_CHAT_INF = 'GET_CHAT_INF'
export const GET_MESSAGE = 'GET_MESSAGE'
export const GET_CHAT_BY_USER = 'GET_CHAT_BY_USER'
export const REMOVE_CHAT_LIST = 'REMOVE_CHAT_LIST'
export const SET_TEMP_CHAT = 'SET_TEMP_CHAT'
export const SET_ACTIVE_CONVERSATION = 'SET_ACTIVE_CONVERSATION'
export const GET_TIME_LINE_ORDER = 'GET_TIME_LINE_ORDER'
